import { Component, OnInit } from '@angular/core';
import { OauthService } from '../../core/oauth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private oauthservice: OauthService) { }

  ngOnInit() {
  }

  logout() {
    this.oauthservice.logoutUser();
  }
  public slideToggle() {
    var navigationTrigger = document.getElementsByClassName("navigation-trigger")[0];
    navigationTrigger.classList.toggle('toggled');
    var sidebarIcon = document.getElementsByClassName("sidebar")[0];
    sidebarIcon.classList.toggle('toggled');
  }
}
